<template>
  <el-dialog :visible.sync="show" width="80%" :close-on-click-modal="false">
    <el-table :data="list" heig="700" :span-method="spanRows">
      <el-table-column label="代采计划" align="center">
        <template slot-scope="scope">
          <div>
            <div>{{ scope.row.planid }}</div>
            <div>{{ scope.row.plan_type }}</div>
            <div>{{ scope.row.create_time }}</div>
            <div v-show="scope.row.is_off_goods">特价商品</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="整期改价" align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.new_plan_price"
            size="small"
            @blur="changePlanPrice(scope.row, scope.$index)"
          ></el-input>
        </template>
      </el-table-column>

      <el-table-column label="SKU改价" align="center">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.new_sku_price"
            size="small"
            @blur="changeSkuPrice(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="商家价" align="center">
        <template slot-scope="scope">
          <div>
            <div>
              {{ scope.row.plan_price }}
            </div>
            <div v-show="scope.row.remove_price">
              <strike>{{ scope.row.remove_price }}</strike>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="颜色"
        prop="co_val"
        align="center"
      ></el-table-column>
      <el-table-column
        label="尺码"
        prop="si_val"
        align="center"
      ></el-table-column>
      <el-table-column label="选择开单" prop="cg_num"></el-table-column>
      <el-table-column
        label="剩余"
        prop="left_num"
        align="center"
      ></el-table-column>
      <el-table-column
        label="前置数量"
        prop="dk_num"
        align="center"
      ></el-table-column>
      <el-table-column
        label="小计"
        prop="total"
        align="center"
      ></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      goods_no: "",
      list: [],

      change_price: false, // 标记是否改过价格
      span_rows_makr: {},
    };
  },

  watch: {
    show(value) {
      if (value == false) {
        // 关闭弹窗的时候, 如果改过了价格, 就改一下父组件的价格
        if (this.change_price) {
          this.$parent.getGoodsFee(this.goods_no);
          this.$parent.getGoodsPrice(this.goods_no);
        }
      }
    },
  },

  methods: {
    calling(goodsNo) {
      this.goods_no = goodsNo;
      this.setList();
    },

    setList() {
      this.$parent
        .post(this.$parent.urls.multi_phase_goods, {
          supply_id: this.$parent.routeParams.supply_id,
          goods_no: this.goods_no,
          is_dispense: this.$parent.routeParams.is_dispense,
        })
        .then((rs) => {
          this.formatList(rs.list);
          this.show = true;
        });
    },

    formatList(list) {
      this.list = [];
      this.span_rows_makr = {};
      let loopTimes = 0;
      list.forEach((row) => {
        row.goods.forEach((item) => {
          this.span_rows_makr[loopTimes] = item.detail.length;
          item.detail.forEach((skuRow) => {
            const total = this.$parent.priceFormat(
              skuRow.cg_num * skuRow.plan_price
            );
            this.list.push({
              new_sku_price: "", // 分期sku改价
              new_plan_price: "", // 整期改价
              planid: row.planid,
              create_time: row.create_time,
              plan_type: row.plan_type,
              // sku: sku_row.sku,
              goods_no: item.goods_no,
              // left_num: sku_row.left_num
              total,
              // 前置数量
              dk_num: Math.abs(Math.min(skuRow.plan_num - skuRow.cg_num, 0)),
              is_off_goods: item.is_off_goods,
              ...skuRow,
            });
            loopTimes += 1;
          });
        });
      });
    },

    // 整期改价
    changePlanPrice(row, index) {
      if (row.new_plan_price === "") {
        return null;
      }
      row.new_plan_price = this.$parent.priceFormat(row.new_plan_price);
      const params = {
        goods_no: row.goods_no,
        price: row.new_plan_price,
        planid: row.planid,
      };
      const rs = this.changePrice(params);
      if (typeof rs === "null") return;

      rs.then((_) => {
        this.change_price = true;
        let loop = this.span_rows_makr[index];
        for (; loop > 0; loop--) {
          console.log(index + loop - 1);
          this.replacePrice(this.list[index + loop - 1], params.price);
        }
      });
    },

    // sku改价
    changeSkuPrice(row) {
      if (row.new_sku_price === "") {
        return null;
      }
      row.new_sku_price = this.$parent.priceFormat(row.new_sku_price);
      const params = {
        sku: row.sku,
        price: row.new_sku_price,
        planid: row.planid,
      };
      const rs = this.changePrice(params);
      if (typeof rs === "null") return;

      rs.then((_) => {
        this.change_price = true;
        this.replacePrice(row);
      });
    },

    replacePrice(row, price) {
      if (row.remove_price == "") {
        row.remove_price = row.plan_price;
      }
      row.plan_price = row.new_sku_price || row.new_plan_price || price;
      row.new_sku_price = "";
      row.new_plan_price = "";

      if (row.remove_price == row.plan_price) {
        row.remove_price = "";
      }
    },

    changePrice(params) {
      const args = {
        supply_id: this.$parent.routeParams.supply_id,
        is_dispense: this.$parent.routeParams.is_dispense,
        // goods_no: row.goods_no,

        ...params,
      };
      return this.$parent
        .post(this.$parent.urls.change_price, args)
        .then(() => {
          this.$message.success("修改价格成功");
        });
    },

    // 合并行
    spanRows({ rowIndex, columnIndex }) {
      let $rows = 1;
      let $columns = 1;
      // 合并第一列和第二列
      if ([0, 1].includes(columnIndex)) {
        if (typeof this.span_rows_makr[rowIndex] !== "undefined") {
          $rows = this.span_rows_makr[rowIndex];
          $columns = 1;
        } else {
          $rows = 0;
          $columns = 0;
        }
      }
      return [$rows, $columns];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/purchaseverify/components/MultiPhaseGoods.vue